/*
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/
const historyRecord = resolve =>
  require(['../../../views/personalCenter/historyRecord'], resolve)

// 咨询-咨询频道
export default [
  // 咨询频道
  {
    path: '/historyRecord',
    component: historyRecord
  }
]



// WEBPACK FOOTER //
// ./src/router/page/personalCenter/historyRecord.js